import { render, staticRenderFns } from "./BaseErrorPage.vue?vue&type=template&id=8845f55e&scoped=true"
import script from "./BaseErrorPage.vue?vue&type=script&lang=js"
export * from "./BaseErrorPage.vue?vue&type=script&lang=js"
import style0 from "./BaseErrorPage.vue?vue&type=style&index=0&id=8845f55e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8845f55e",
  null
  
)

export default component.exports